import highlight from "./highlight_template";
import { initHighlight, highlightImages, highlightCondenced, highlightImageCondenced, nextPrevHtml } from "./highlight_template";
import { articlesExtend, getDynamicContent, findsite, getFromContent, postImplementImage } from "src/scripts/mixin";
import show404 from "src/components/show404/show404";
import {updateElementsHeightAndPosition} from "src/components/highlight/highlight_postrender";
// import {} from "src/scripts/mixin";

export default () => {


    return initHighlight();


}


export const highlight_start = (cb) => {

    let categoryid = document.querySelector(".navigation__button-active").dataset.categoryid;
    // console.log(categoryid);
    let senddata = {
        "categoryId": categoryid,
        "subscriptionId": config.clientId
    };

    fetch(window.apiUrl + "/api/PublicContentApi/getbycategoryidasstring", { //
            method: 'POST', // or 'PUT'
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(senddata),
        })
        .then(response => response.json())
        .then(data => {

            // console.log("getbycategoryidasstring", data);

            // let block = data.listOfContent;
            let items = [];

            let html = ``;
            let right_ = true;

            // console.log(data);
            if (data.length > 0) {
                //sorting
                data.forEach(item => {

                    let year = 0;
                    let title = item.title;

                    if (item.title.match(":")) {
                        let titlesplit = item.title.split(":")
                        item.year = parseInt(titlesplit[0]);
                        item.title = titlesplit[1];
                    }
                    if (categoryid !== window.highlightid) {
                        item.year = parseInt(title);
                    }

                });

                data.sort((a, b) => a.year > b.year ? 1 : -1);


                let first = true;
                let itemcount = 0;

                // console.log("...",data);
                data.forEach(item => {
                    item = articlesExtend(item);

                    // console.log(item);

                    if (right_ === true)
                        right_ = false
                    else
                        right_ = true;

                    if (!item.intro) {
                        // console.log("no intro");
                        let ps = getFromContent(item.contentParsed, "p");
                        // console.log(ps);

                        if (ps.length > 0) {
                            var nrps = 0;
                            ps.forEach(paragraph => {
                                if (nrps < 1) {
                                    // console.log("p", nrps, paragraph.innerHTML)
                                    item.intro = paragraph.innerHTML;
                                }
                                nrps++;
                            })
                        }
                        else {
                            console.log("no ps");
                        }

                    }

                    let imagesobj = [];
                    const imgclass = ["first", "second", "third"];
                    let imgcount = 0;

                    if (item.metaParsed) {
                        if (item.metaParsed.imageContentId) {

                            // console.log("hasImage",item.metaParsed);

                            imagesobj.push({
                                src: "",
                                dataid: item.metaParsed.imageContentId,
                                desc: item.metaParsed.imageDescription,
                                cssclass: "image__unresolved image__main highlight__img-" + imgclass[imgcount]
                            })

                            imgcount++;

                        }
                    }
                    let contentImages = getFromContent(item.contentParsed, "img");
                    // let img_count = 0
                    if (contentImages.length > 0) {
                        contentImages.forEach(img => {

                            imagesobj.push({
                                src: img.src,
                                desc: item.alt,
                                cssclass: " highlight__img-" + imgclass[imgcount]
                            })
                            // img_count++;
                            imgcount++;
                        })
                    }

                    imagesobj = imagesobj.slice(0, 3);

                    // console.log(images);
                    let images = [];
                    let imagescount = 0;
                    imagesobj.forEach(img => {
                        imagescount++;
                        if(imagesobj.length === 1) {
                            img.cssclass = img.cssclass + " highlight__img-full highlight__img-onlyone";
                        }
                        if (imagesobj.length === 2 && imagescount === 2) {
                            img.cssclass = img.cssclass + " highlight__img-full";
                        }
                        images.push(highlightImages(img));
                    });

                    // let skipHorizontal = false;
                    let year_ = item.year;

                    if (categoryid !== window.highlightid) {
                        // alert("test");
                        item.condenced = true;
                        right_ = false;
                        // year_ = item.title;
                    }

                    // console.log("url", item)

                    if (item.nameInUrl === null) {
                        item.nameInUrl = item.contentId;
                    }

                    if (!item.condenced) {
                        items.push(highlight({
                            intro: item.intro,
                            order: itemcount,
                            year: item.year,
                            first: first,
                            right: right_,
                            title: item.title,
                            images: images.join(""),
                            contentParsed: item.contentParsed,
                            url: item.nameInUrl
                        }));
                    }
                    else {

                        // console.log(imagesobj);
                        items.push(highlightCondenced({
                            intro: item.intro,
                            order: itemcount,
                            year: item.year,
                            first: first,
                            right: right_,
                            title: item.title,
                            images: (imagesobj[0] ? highlightImageCondenced(imagesobj[0]) : false),
                            contentParsed: item.contentParsed
                        }));
                    }

                    itemcount++;

                    if (first == true) {
                        first = false;
                    }

                });


                const currentNav = document.querySelector(".navigation__button-active");
                const nextNav = currentNav.nextSibling;
                const prevNav = currentNav.previousSibling;

                // console.log(prevNav,nextNav);

                let prev = false;
                let next = false;

                if (prevNav.dataset) {
                    prev = {
                        title: prevNav.innerHTML,
                        url: prevNav.getAttribute("href")
                    }
                }

                if (nextNav.dataset) {
                    next = {
                        title: nextNav.innerHTML,
                        url: nextNav.getAttribute("href")
                    }
                }

                document.getElementById("site_highlight").innerHTML = items.join("") + nextPrevHtml(prev, next);


                document.querySelectorAll(".pageing__link").forEach(item => {

                    item.addEventListener("click", link => {
                        // window.scroll({
                        //     top: 0,
                        //     left: 0,
                        //     behavior: 'smooth'
                        // });

                    }, false);

                });
                
                
                postImplementImage(() => {
                    // console.log("test");
                    updateElementsHeightAndPosition();
                });


            }
            else {
                
                document.getElementById("site_highlight").innerHTML = show404();
            }

            // console.log("postRenderFunctions");

            if (typeof cb === "function") {
                cb();
            }
        });
}


export const setHighlightPage = () => {

    // if(elm.dataset.categoryid === window.highlightid){
    // document.querySelector(".highlight__row[data-order='0']").scrollIntoView({behavior:"smooth"})
    // }
    // else {
    highlight_start();
    // }
}
